import { render } from "./Menu_pc.vue?vue&type=template&id=23a7fe81&scoped=true"
import script from "./Menu_pc.vue?vue&type=script&lang=js"
export * from "./Menu_pc.vue?vue&type=script&lang=js"

import "./Menu_pc.vue?vue&type=style&index=0&id=23a7fe81&scoped=true&lang=css"

import exportComponent from "/Users/bencorp/Desktop/proyectos/Fitbar/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23a7fe81"]])

export default __exports__